import * as React from 'react';

import {FileUploadButton} from '../button/file-upload-button/file-upload-button';
import {getFileIcon} from '../icon/get-icon';

import styles from './file-upload.module.css';

type File = {
    name: string;
    size: string;
    type: string;
};

type Props = {
    id: string;
    name: string;
    accept: string;
    maxFileSize?: string;
    onChange?: (newFile: File) => void;
    enableDropping?: boolean;
};

export function FileUpload(props: Props) {
    const [file, setFile] = React.useState('');

    return (
        <div className={styles['file-upload']}>
            <FileUploadButton
                accept={props.accept}
                name={props.name}
                id={props.id}
                enableDropping={props.enableDropping}
                onChange={(uploadedFile) => {
                    setFile(uploadedFile);

                    if (props.onChange) {
                        props.onChange(uploadedFile);
                    }
                }}
            />
            {file ? (
                // @ts-expect-error
                <SelectedFile file={file} />
            ) : (
                <div className={styles['file-text']}>
                    <i>No file chosen</i>
                    {props.maxFileSize ? (
                        <i>&nbsp;– Max file size: {props.maxFileSize}</i>
                    ) : undefined}
                </div>
            )}
        </div>
    );
}

function SelectedFile({file}: {file: File}) {
    const IconComponent = getFileIcon(file.type);

    return (
        <div className={styles['selected-file']}>
            <IconComponent size={14} alignCenter={true} /> {file.name}
        </div>
    );
}
